import { Layer } from '~/packages/general/variable/spaceTime.types'
import { MapType } from '../../map/mapContext'
import { VariableAndOptionalResult } from '~/packages/general/variable/variables.typing'

export const mapTypes: MapType[] = ['roadmap', 'hybrid', 'terrain']

export const mapTypesLabels: Record<MapType, string> = {
  roadmap: 'Mapa',
  satellite: 'Satélite sem rótulos',
  terrain: 'Terreno',
  hybrid: 'Satélite',
  streetView: 'Street View',
} as const

export type Map3DOption = 'on' | 'whenNecessary' | 'off'

export const map3DOptions: Map3DOption[] = ['on', 'whenNecessary', 'off']

export const map3DOptionsLabels: Record<Map3DOption, string> = {
  on: 'Habilitado',
  whenNecessary: 'Quando necessário',
  off: 'Desabilitado',
} as const

export interface MapMenuProps {
  onChangeMapType: (newMapType: MapType) => void
  mapType: MapType
  onChangeMap3DOption: (newMap3DOption: Map3DOption) => void
  map3DOption: Map3DOption
  layers: Layer[]
  variables: VariableAndOptionalResult[]
  onChangeLayers: (layers: Layer[] | ((layers: Layer[]) => Layer[])) => void
  canAddLayer?: boolean
  children?: React.ReactNode
}
